/**
 * @typedef {{
 *   agentHeader?: Function;
 *   browserCodename: string;
 *   browserLanguage: string;
 *   browserName: string;
 *   browserOnline: boolean;
 *   browserVersion: string;
 *   cookiesEnabled: boolean;
 *   deviceInfo: string;
 *   os: string;
 *   osVersion: string;
 *   platform: string;
 *   screenSize: string;
 *   userAgentHeader?: string;
 * }} DeviceDetails
 */

var Utils = {};

const globalAny = global;
globalAny.navigator = global.navigator;

/*eslint-disable no-extend-native*/
if ( ! [].fill ) {
	Array.prototype.fill = function ( value ) {
		var O = Object( this );
		var len = parseInt( O.length, 10 );
		var start = arguments[ 1 ];
		var relativeStart = parseInt( start, 10 ) || 0;
		var k = relativeStart < 0 ? Math.max( len + relativeStart, 0 ) : Math.min( relativeStart, len );
		var end = arguments[ 2 ];
		var relativeEnd = end === undefined ? len : parseInt( end ) || 0;
		var final = relativeEnd < 0 ? Math.max( len + relativeEnd, 0 ) : Math.min( relativeEnd, len );

		for ( ; k < final; k++ ) {
			O[ k ] = value;
		}

		return O;
	};
}
/*eslint-enable no-extend-native*/

Utils.constants = {
	DEVELOPMENT: 'development',
	PREVIEW: 'preview',
	PRODUCTION: 'production',
	STAGING: 'staging',
	PERSONAL: 'personal',
	PRIORITY: 'priority',
	BUSINESS: 'business',
	CORPORATE: 'corporate',
	PRIVATE: 'private',
	COMMERCIAL: 'commercial',

	LANGUAGES: [ 'en', 'zh' ],

	ALLOWABLE_QUERYSTRING: {
		scb: [
			'subChanCode',
			'camp_id',
			'pid',
			'promoCode',
			'promo',
			'referId',
			'instance',
			'state',
			'utm_source',
			'utm_medium',
			'utm_campaign',
			'utm_term',
			'utm_content',
			'GiPrm',
			'productName',
			'truspleBuyerId',
			'CTID',
		],
		others: [ 'gclid', 'gclsrc' ],
	},
};

Utils.extend = function ( obj, src ) {
	Object.keys( src ).forEach( function ( key ) {
		obj[ key ] = src[ key ];
	} );
	return obj;
};
/**
 * Get the country code from the URL
 *
 * @returns {*} get the country code
 */
Utils.getCountryNameFromURL = function () {
	var url = window.location.href;
	var removeHTTP = url.replace( 'http://', '' ).replace( 'https://', '' );
	var splitURL = removeHTTP.split( '/' );
	var currentEnvironment = Utils.getCurrentEnvironment();
	return Utils.constants.DEVELOPMENT === currentEnvironment || Utils.constants.STAGING === currentEnvironment
		? splitURL[ 2 ]
		: splitURL[ 1 ];
};

/**
 * Get the user agent of the current browser
 *
 * TODO: Replace deprecated properties.
 *
 * @returns {DeviceDetails}
 */
Utils.getDeviceDetails = function () {
	var os = '';

	var nAgt = globalAny.navigator?.userAgent;
	var clientStrings = [
		{
			s: 'W 10',
			r: /(Windows 10.0|Windows NT 10.0)/,
		},
		{
			s: 'W 8.1',
			r: /(Windows 8.1|Windows NT 6.3)/,
		},
		{
			s: 'W 8',
			r: /(Windows 8|Windows NT 6.2)/,
		},
		{
			s: 'W 7',
			r: /(Windows 7|Windows NT 6.1)/,
		},
		{
			s: 'W Vista',
			r: /Windows NT 6.0/,
		},
		{
			s: 'W Server 2003',
			r: /Windows NT 5.2/,
		},
		{
			s: 'W XP',
			r: /(Windows NT 5.1|Windows XP)/,
		},
		{
			s: 'W 2000',
			r: /(Windows NT 5.0|Windows 2000)/,
		},
		{
			s: 'W ME',
			r: /(Win 9x 4.90|Windows ME)/,
		},
		{
			s: 'W 98',
			r: /(Windows 98|Win98)/,
		},
		{
			s: 'W 95',
			r: /(Windows 95|Win95|Windows_95)/,
		},
		{
			s: 'W NT 4.0',
			r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/,
		},
		{
			s: 'W CE',
			r: /Windows CE/,
		},
		{
			s: 'W 3.11',
			r: /Win16/,
		},
		{
			s: 'Android',
			r: /Android/,
		},
		{
			s: 'Open BSD',
			r: /OpenBSD/,
		},
		{
			s: 'Sun OS',
			r: /SunOS/,
		},
		{
			s: 'L',
			r: /(Linux|X11)/,
		},
		{
			s: 'iOS',
			r: /(iPhone|iPad|iPod)/,
		},
		{
			s: 'Mac OS X',
			r: /Mac OS X/,
		},
		{
			s: 'Mac OS',
			r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/,
		},
		{
			s: 'QNX',
			r: /QNX/,
		},
		{
			s: 'U',
			r: /UNIX/,
		},
		{
			s: 'BeOS',
			r: /BeOS/,
		},
		{
			s: 'OS/2',
			r: /OS\/2/,
		},
		{
			s: 'Search Bot',
			r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
		},
	];
	for ( var id in clientStrings ) {
		var cs = clientStrings[ id ];
		if ( cs.r.test( nAgt ) ) {
			os = cs.s;
			break;
		}
	}

	var osVersion = '';
	if ( /Windows/.test( os ) ) {
		osVersion = /Windows (.*)/.exec( os )[ 1 ];
		os = 'Windows';
	}

	switch ( os ) {
		case 'Mac OS X': {
			const macMatch = /Mac OS X (10|11[._\d]+)/.exec( nAgt );
			osVersion = macMatch ? macMatch[1] : 'Unknown';
			break;
		}
		case 'Android': {
			const androidMatch = /Android ([._\d]+)/.exec( nAgt );
			osVersion = androidMatch ? androidMatch[1] : 'Unknown';
			break;
		}

		case 'iOS': {
			const iOSMatch = /OS (\d+)_(\d+)_?(\d+)?/.exec( nAgt );
			osVersion = iOSMatch ? iOSMatch[1] + '.' + iOSMatch[2] + '.' + ( iOSMatch[3] || 0 ) : 'Unknown';
			break;
		}
		default: //do nothing
			break;
	}

	var deviceInfo = 'd';
	if ( /Mobi/.test( globalAny.navigator?.userAgent ) ) {
		deviceInfo = 'm';
	}

	var screenSize = '',
		width = 0,
		height = 0;
	if ( window.screen.width ) {
		width = window.screen.width ? window.screen.width : '';
		height = window.screen.height ? window.screen.height : '';
		screenSize += '' + width + ' x ' + height;
	}

	return {
		browserCodename: navigator.appCodeName,
		browserName: navigator.appName,
		browserVersion: navigator.appVersion,
		cookiesEnabled: navigator.cookieEnabled,
		browserLanguage: navigator.language,
		browserOnline: navigator.onLine,
		platform: navigator.platform,
		userAgentHeader: globalAny.navigator?.userAgent,
		agentHeader: navigator.getAgent,
		deviceInfo: deviceInfo,
		screenSize: screenSize,
		os: os,
		osVersion: osVersion,
	};
};
var urlObj = [
	'cmsdev',
	'preview',
	'standardchartered',
	'sc',
	'com',
	'av',
	'assets',
	'global',
	'development',
	'staging',
	'digital',
	'https',
	'cmsstage',
	'cms',
	'dev',
	'zoo',
];
Utils.getCurrentEnvironment = function () {
	var domain = Utils.getPageUrl().domain;
	if ( domain.indexOf( urlObj[ 3 ] + '.' + urlObj[ 4 ] ) !== -1 ) {
		if ( domain === urlObj[ 0 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ] ) {
			return Utils.constants.DEVELOPMENT;
		} else if ( domain === urlObj[ 12 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ] ) {
			return Utils.constants.STAGING;
		} else if ( domain === urlObj[ 13 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ] ) {
			return Utils.constants.PREVIEW;
		} else {
			return Utils.constants.PRODUCTION;
		}
	} else if ( domain === urlObj[ 1 ] + '.' + urlObj[ 2 ] + '.' + urlObj[ 4 ] ) {
		if ( Utils.getPageUrl().pathname.match( '^/staging' ) ) {
			return Utils.constants.STAGING;
		} else if ( Utils.getPageUrl().pathname.match( '^/development' ) ) {
			return Utils.constants.DEVELOPMENT;
		} else {
			return Utils.constants.PREVIEW;
		}
	} else {
		return Utils.constants.DEVELOPMENT;
	}
};

Utils.getAssetDomain = function () {
	/* eslint-disable no-undef*/
	if ( typeof baseURL === 'undefined' || baseURL === '' ) {
		var env = Utils.getCurrentEnvironment();
		var domain = Utils.getPageUrl().domain;
		if ( env === Utils.constants.PRODUCTION ) {
			return (
				urlObj[ 11 ] +
				'://' +
				urlObj[ 5 ] +
				'.' +
				urlObj[ 3 ] +
				'.' +
				urlObj[ 4 ] +
				'/' +
				urlObj[ 6 ] +
				'/' +
				urlObj[ 7 ] +
				'/'
			);
		} else if ( env === Utils.constants.DEVELOPMENT ) {
			if ( domain === urlObj[ 3 ] + '.' + urlObj[ 14 ] ) {
				return '/content/themes/scretail/assets/global/';
			} else if (
				domain === urlObj[ 1 ] + '.' + urlObj[ 2 ] + '.' + urlObj[ 4 ] ||
				domain === urlObj[ 0 ] + '.' + urlObj[ 3 ] + '.' + urlObj[ 4 ]
			) {
				return (
					urlObj[ 11 ] +
					'://' +
					urlObj[ 1 ] +
					'.' +
					urlObj[ 2 ] +
					'.' +
					urlObj[ 4 ] +
					'/' +
					urlObj[ 8 ] +
					'/' +
					urlObj[ 6 ] +
					'/' +
					urlObj[ 7 ] +
					'/'
				);
			} else {
				return '/assets/';
			}
		} else if ( env === Utils.constants.STAGING ) {
			return (
				urlObj[ 11 ] +
				'://' +
				urlObj[ 1 ] +
				'.' +
				urlObj[ 2 ] +
				'.' +
				urlObj[ 4 ] +
				'/' +
				urlObj[ 9 ] +
				'/' +
				urlObj[ 6 ] +
				'/' +
				urlObj[ 7 ] +
				'/'
			);
		} else {
			return (
				urlObj[ 11 ] +
				'://' +
				urlObj[ 1 ] +
				'.' +
				urlObj[ 2 ] +
				'.' +
				urlObj[ 4 ] +
				'/' +
				urlObj[ 6 ] +
				'/' +
				urlObj[ 7 ] +
				'/'
			);
		}
	} else if ( baseURL === '/zoo' ) {
		return (
			urlObj[ 11 ] +
			'://' +
			urlObj[ 10 ] +
			'.' +
			urlObj[ 3 ] +
			'.' +
			urlObj[ 4 ] +
			'/' +
			urlObj[ 15 ] +
			'/' +
			urlObj[ 6 ] +
			'/'
		);
	} else {
		return baseURL;
	}
	/* eslint-enable no-undef*/
};

Utils.getDistanceFromLatLonInKm = function ( lat1, lon1, lat2, lon2 ) {
	var R = 6371; // Radius of the earth in km
	var dLat = Utils.deg2rad( lat2 - lat1 ); // deg2rad below
	var dLon = Utils.deg2rad( lon2 - lon1 );
	var a =
		Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
		Math.cos( Utils.deg2rad( lat1 ) ) *
			Math.cos( Utils.deg2rad( lat2 ) ) *
			Math.sin( dLon / 2 ) *
			Math.sin( dLon / 2 );
	var c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
	var d = R * c; // Distance in km
	return d;
};

Utils.getPageContext = function () {
	var $title = document.title;
	var $country = document.querySelector( 'meta[name="sc:country"]' );
	var $language = document.querySelector( 'meta[name="sc:language"]' );
	var $segment = document.querySelector( 'meta[name="sc:segment"]' );
	var $category = document.querySelector( 'meta[name="sc:categories"]' );
	var $subcategory = document.querySelector( 'meta[name="sc:subcategories"]' );
	var $slug = document.querySelector( 'meta[name="sc:page-slug"]' );

	var pageContext = {
		title: null,
		country: null,
		language: null,
		segment: null,
		category: null,
		subcategory: null,
		slug: null,
	};

	if ( $title ) {
		pageContext.title = $title;
	}

	if ( $country ) {
		pageContext.country = $country.getAttribute( 'content' );
	}

	if ( $language ) {
		pageContext.language = $language.getAttribute( 'content' );
	}

	if ( ! pageContext.language ) {
		var docLang = document.documentElement.lang;
		if ( docLang ) {
			// Document language can be in languageCode-countryCode format, e.g en-US.
			// In front-end context, we don't need countryCode part
			pageContext.language = docLang.split( '-' )[ 0 ].toLowerCase();
		}
	}

	if ( $segment ) {
		pageContext.segment = $segment.getAttribute( 'content' );
	}

	if ( $category ) {
		pageContext.category = $category.getAttribute( 'content' );
	}

	if ( $subcategory ) {
		pageContext.subcategory = $subcategory.getAttribute( 'content' );
	}

	if ( $slug ) {
		pageContext.slug = $slug.getAttribute( 'content' );
	}

	return Utils.extend( Utils.urlBreakdown( window.location.href ), pageContext );
};

Utils.getPageUrl = function () {
	return Utils.getPageContext();
};

Utils.getImageUrl = function ( url ) {
	var imgBreakdown = url.split( '/' );
	var file = imgBreakdown[ imgBreakdown.length - 1 ];
	var fileParts = file.split( '.' );
	return {
		file: file,
		name: fileParts[ 0 ],
		extension: fileParts[ 1 ],
	};
};

Utils.getCurrentTimestamp = function () {
	// Get local time as ISO string with offset at the end
	var now = new Date();
	var tzo = -now.getTimezoneOffset();
	var dif = tzo >= 0 ? '+' : '-';
	var pad = function ( num ) {
		var norm = Math.abs( Math.floor( num ) );
		return ( norm < 10 ? '0' : '' ) + norm;
	};
	return (
		now.getFullYear() +
		'-' +
		pad( now.getMonth() + 1 ) +
		'-' +
		pad( now.getDate() ) +
		'T' +
		pad( now.getHours() ) +
		':' +
		pad( now.getMinutes() ) +
		':' +
		pad( now.getSeconds() ) +
		'.' +
		pad( now.getMilliseconds() ) +
		dif +
		pad( tzo / 60 ) +
		':' +
		pad( tzo % 60 )
	);
};

Utils.getCurrentTime = function () {
	return new Date().getTime();
};

Utils.getTrafficSource = function () {
	var _ref = document.referrer;
	if ( _ref.toLowerCase().indexOf( 'google' ) > -1 ) {
		return 'go';
	} else if ( _ref.toLowerCase().indexOf( 'yahoo' ) > -1 ) {
		return 'yo';
	} else if ( _ref.toLowerCase().indexOf( 'bing' ) > -1 ) {
		return 'bn';
	} else if ( _ref.toLowerCase().indexOf( 'baidu' ) > -1 ) {
		return 'bd';
	} else if ( _ref === '' ) {
		return 'direct';
	} else {
		return 'unknown';
	}
};

Utils.browserDetect = {
	init: function () {
		this.name = this.searchString( this.dataBrowser ) || 'Other';

		this.version =
			this.searchVersion( globalAny.navigator?.userAgent ) ||
			this.searchVersion( navigator.appVersion ) ||
			'Unknown';
	},
	searchString: function ( data ) {
		for ( var i = 0; i < data.length; i++ ) {
			var dataString = data[ i ].string;
			this.versionSearchString = data[ i ].subString;

			if ( dataString.indexOf( data[ i ].subString ) !== -1 ) {
				return data[ i ].identity;
			}
		}
	},
	searchVersion: function ( dataString ) {
		var index = dataString.indexOf( this.versionSearchString );
		if ( index === -1 ) {
			return;
		}

		var rv = dataString.indexOf( 'rv:' );
		if ( this.versionSearchString === 'Trident' && rv !== -1 ) {
			return parseFloat( dataString.substring( rv + 3 ) );
		} else {
			return parseFloat( dataString.substring( index + this.versionSearchString.length + 1 ) );
		}
	},

	dataBrowser: [
		{
			string: globalAny.navigator?.userAgent,
			subString: 'Edge',
			identity: 'MS Edge',
		},
		{
			string: globalAny.navigator?.userAgent,
			subString: 'MSIE',
			identity: 'Explorer',
		},
		{
			string: globalAny.navigator?.userAgent,
			subString: 'Trident',
			identity: 'Explorer',
		},
		{
			string: globalAny.navigator?.userAgent,
			subString: 'Firefox',
			identity: 'Firefox',
		},
		{
			string: globalAny.navigator?.userAgent,
			subString: 'Opera',
			identity: 'Opera',
		},
		{
			string: globalAny.navigator?.userAgent,
			subString: 'OPR',
			identity: 'Opera',
		},

		{
			string: globalAny.navigator?.userAgent,
			subString: 'Chrome',
			identity: 'Chrome',
		},
		{
			string: globalAny.navigator?.userAgent,
			subString: 'Safari',
			identity: 'Safari',
		},
	],
};

Utils.generateUniqueId = function () {
	var uid = function () {
		return Math.floor( ( 1 + Math.random() ) * 0x10000 )
			.toString( 16 )
			.substring( 1 );
	};

	return uid() + uid() + '-' + uid() + '-' + uid() + '-' + uid() + '-' + uid() + uid() + uid();
};

Utils.trim = function ( text ) {
	if ( text ) {
		return text.trim();
	}

	return text;
};

Utils.previewLog = function ( log ) {
	if (
		Utils.getCurrentEnvironment() === Utils.constants.PREVIEW ||
		Utils.getCurrentEnvironment() === Utils.constants.DEVELOPMENT
	) {
		/* eslint-disable no-console */
		if ( typeof console !== 'undefined' && typeof console.log !== 'undefined' ) {
			console.log( log );
		}
		/* eslint-enable no-console */
	}
};

Utils.resizeIframe = function ( obj ) {
	obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
};

Utils.deg2rad = function ( deg ) {
	return deg * ( Math.PI / 180 );
};

Utils.urlBreakdown = function ( currentURL ) {
	var parser = Utils.parseUrl( currentURL );
	var queryString = parser.search,
		parts = parser.pathname.split( '/' ),
		hash = parser.hash,
		countryMapping = {
			sgbeta: 'sg',
		};
	if ( queryString && queryString.indexOf( '?' ) === 0 ) {
		queryString = queryString.slice( 1 );
	}
	var pageURL = {
		domain: null,
		country: null,
		language: null,
		category: null,
		segment: 'personal',
		subcategory: null,
		slug: null,
		queryString: queryString,
		hash: null,
		pathname: document.location.pathname,
	};

	var devOrStaging = parts[ 1 ] === 'development' || parts[ 1 ] === 'staging' ? true : false;

	pageURL.domain = parser.hostname;
	pageURL.country = devOrStaging ? parts[ 2 ] : parts[ 1 ];
	pageURL.language = 'en';

	if ( pageURL.country === 'cn' ) {
		pageURL.language = 'zh';
	}

	if ( devOrStaging ) {
		pageURL.category = parts[ 3 ];
		if ( parts[ 3 ].length === 3 ) {
			pageURL.language = parts[ 3 ];
			pageURL.category = parts[ 4 ];
		}
	} else if ( parts[ 2 ] ) {
		pageURL.category = parts[ 2 ];
		if ( parts[ 2 ].length === 2 ) {
			pageURL.language = parts[ 2 ];
			pageURL.category = parts[ 3 ];
		}
	}

	if ( parts[ parts.length - 1 ] !== '' && parts[ parts.length - 1 ] !== 'index.html' ) {
		pageURL.slug = parts[ parts.length - 1 ];
	} else {
		pageURL.slug = parts[ parts.length - 2 ];
	}

	if ( pageURL.slug ) {
		if ( pageURL.slug.indexOf( '.' ) !== -1 ) {
			var slugger = pageURL.slug.split( '.' );
			pageURL.name = slugger[ 0 ];
			pageURL.extension = slugger[ 1 ];
		} else {
			pageURL.name = pageURL.slug;
			pageURL.extension = '';
		}
	} else {
		pageURL.slug = '';
		pageURL.name = '';
		pageURL.extension = '';
	}

	if ( parts.length <= 4 && Utils.constants.LANGUAGES.indexOf( pageURL.slug ) !== -1 ) {
		pageURL.slug = pageURL.country;
	}

	if ( hash ) {
		pageURL.hash = hash;
	}

	if ( parts.length >= 5 ) {
		pageURL.subcategory = devOrStaging ? parts[ 4 ] : parts[ 3 ];
	}

	if ( pageURL.pathname.indexOf( 'priority' ) !== -1 ) {
		pageURL.segment = 'priority';
	} else if ( pageURL.pathname.indexOf( 'business' ) !== -1 ) {
		pageURL.segment = 'business';
	}

	if ( countryMapping[ pageURL.country ] ) {
		pageURL.country = countryMapping[ pageURL.country ];
	}

	return pageURL;
};

Utils.objectLength = function ( object ) {
	var length = 0;
	for ( var key in object ) {
		// eslint-disable-next-line no-prototype-builtins
		if ( object.hasOwnProperty( key ) ) {
			++length;
		}
	}
	return length;
};

Utils.countryCodeConverter = function ( code, lang ) {
	var countryCode = {
		en: {
			sg: 'Singapore',
			sgbeta: 'Singapore',
			hk: 'Hong Kong',
			hkbeta: 'Hong Kong',
			in: 'India',
			inbeta: 'India',
			cn: 'China',
			cnbeta: 'China',
			my: 'Malaysia',
			mybeta: 'Malaysia',
			ae: 'UAE',
			aebeta: 'UAE',
			vn: 'Vietnam',
			vnbeta: 'Vietnam',
			ci: 'Côte d’Ivoire',
			cibeta: 'Côte d’Ivoire',
			bh: 'Bahrain',
			bhbeta: 'Bahrain',
			bw: 'Botswana',
			bwbeta: 'Botswana',
			gh: 'Ghana',
			ghbeta: 'Ghana',
			id: 'Indonesia',
			idbeta: 'Indonesia',
			ng: 'Nigeria',
			ngbeta: 'Nigeria',
			ph: 'Philippines',
			phbeta: 'Philippines',
			lk: 'Sri Lanka',
			lkbeta: 'Sri Lanka',
			th: 'Thailand',
			thbeta: 'Thailand',
			bd: 'Bangladesh',
			bdbeta: 'Bangladesh',
			om: 'Oman',
			ombeta: 'Oman',
			fi: 'Falkland Islands',
			fibeta: 'Falkland Islands',
			np: 'Nepal',
			npbeta: 'Nepal',
			bn: 'Brunei',
			bnbeta: 'Brunei',
			zw: 'Zimbabwe',
			zwbeta: 'Zimbabwe',
			zm: 'Zambia',
			zmbeta: 'Zambia',
			ug: 'Uganda',
			ugbeta: 'Uganda',
			tz: 'Tanzania',
			tzbeta: 'Tanzania',
			sl: 'Sierra Leone',
			slbeta: 'Sierra Leone',
			qa: 'Qatar',
			qabeta: 'Qatar',
			pk: 'Pakistan',
			pkbeta: 'Pakistan',
			ke: 'Kenya',
			kebeta: 'Kenya',
			jo: 'Jordan',
			jobeta: 'Jordan',
			je: 'Jersey',
			jebeta: 'Jersey',
		},
	};

	if ( ! code ) {
		return countryCode[ 'en' ][ 'sg' ];
	} else {
		if ( ! lang ) {
			if ( countryCode[ 'en' ][ code.toLowerCase() ] ) {
				return countryCode[ 'en' ][ code.toLowerCase() ];
			} else {
				return countryCode[ 'en' ][ 'sg' ];
			}
		} else {
			return countryCode[ lang ][ code.toLowerCase() ];
		}
	}
};

Utils.convertQueryStringToJsonObject = function ( queryString ) {
	var queries = queryString.split( '&' );
	var json = {};
	for ( var i = 0; i < queries.length; i++ ) {
		var keyValue = queries[ i ].split( '=' );
		if ( keyValue.length === 2 ) {
			json[ keyValue[ 0 ].toLowerCase() ] = keyValue[ 1 ];
		}
	}

	return json;
};

Utils.setCookie = function ( values, days, path ) {
	var expiry = '',
		paths = '';
	if ( days ) {
		var dt = new Date();
		dt.setTime( dt.getTime() + days * 24 * 60 * 60 * 1000 );
		expiry = '; expires=' + dt.toUTCString();
	}

	if ( path ) {
		paths = ';path=' + path;
	}

	if ( values ) {
		for ( var k in values ) {
			// eslint-disable-next-line no-prototype-builtins
			if ( values.hasOwnProperty( k ) ) {
				document.cookie = k + '=' + values[ k ] + expiry + paths;
			}
		}
	}
};

Utils.getCookie = function ( key ) {
	var name = key + '=';
	var decodedCookie = decodeURIComponent( document.cookie );
	var ca = decodedCookie.split( ';' );
	for ( var i = 0; i < ca.length; i++ ) {
		var c = ca[ i ];
		while ( c.charAt( 0 ) === ' ' ) {
			c = c.substring( 1 );
		}
		if ( c.indexOf( name ) === 0 ) {
			return c.substring( name.length, c.length );
		}
	}

	return null;
};

Utils.isEmpty = function ( obj ) {
	// null and undefined are "empty"
	if ( obj == null ) return true;

	// Assume if it has a length property with a non-zero value
	// that that property is correct.
	if ( obj.length > 0 ) return false;
	if ( obj.length === 0 ) return true;

	// If it isn't an object at this point
	// it is empty, but it can't be anything *but* empty
	// Is it empty?  Depends on your application.
	if ( typeof obj !== 'object' ) return true;

	// Otherwise, does it have any properties of its own?
	// Note that this doesn't handle
	// toString and valueOf enumeration bugs in IE < 9
	for ( var key in obj ) {
		if ( hasOwnProperty.call( obj, key ) ) return false;
	}

	return true;
};

Utils.getUrlVar = function ( name, url = window.location.href ) {
	var results = new RegExp( '[?&]' + name + '=([^&#]*)' ).exec( url );
	if ( results === null ) {
		return null;
	} else {
		return results[ 1 ] || 0;
	}
};

/*
 * Update value of an existing Parameter in URL/Link.
 * @param {string} url URL or link to update
 * @param {string} name Name of parameter for which value to be updated
 * @param {string} value Value of parameter to update
 * @return {string} URL/Link after replacement of parameter value
 */
Utils.updateUrlVar = function ( url, name, value ) {
	if ( ! url || ! Utils.getUrlVar( name, url ) || ! value ) {
		return null;
	} else {
		var param = new RegExp( '\\b' + name + '=[^&]*' );
		return url.replace( param, name + '=' + value );
	}
};

/*
 * Checks whether or not object is a valid JSON
 * @param {object} object Object to check JSON validity
 * @return {boolean} True if object is a valid JSON, false otherwise
 */
Utils.isValidJSON = function ( object ) {
	try {
		JSON.parse( object );
	} catch ( e ) {
		return false;
	}
	return true;
};
Utils.jsonMerge = function ( json_a, json_b ) {
	let result = [],
		sequencing = [],
		sequenced = [];
	if ( typeof json_a[ 0 ] !== 'undefined' && typeof json_b[ 0 ] !== 'undefined' ) {
		result = json_a[ 0 ];
		var merging = json_b[ 0 ][ 0 ].options.banners;

		// eslint-disable-next-line no-unused-vars
		for ( let k in merging ) {
			if ( typeof merging[ k ] !== 'undefined' && merging[ k ] !== null ) {
				var mergerKey = Utils.getKeyIfPropValInArray( 'id', merging[ k ][ 'id' ], result );
				if ( mergerKey ) {
					sequencing[ k ] = parseInt( mergerKey );
					result[ mergerKey ] = Utils.recursiveObjMerge( result[ mergerKey ], merging[ k ] );
					delete merging[ k ];
				} else {
					sequencing[ k ] = null;
				}
			} else {
				sequencing[ k ] = null;
			}
		}

		// eslint-disable-next-line no-unused-vars
		for ( var k in merging ) {
			if ( typeof merging[ k ] !== 'undefined' && merging[ k ] !== null ) {
				result.push( merging[ k ] );
			}
		}

		var maxKey = sequencing.length >= result.length ? sequencing.length - 1 : result.length - 1;

		var used = [];
		for ( var i = 0; i <= maxKey; i++ ) {
			var seqValue = sequencing[ i ];

			if ( seqValue !== null ) {
				sequenced.push( result[ seqValue ] );
				used.push( result[ seqValue ].id );
			} else {
				// eslint-disable-next-line no-unused-vars
				for ( let k in result ) {
					k = parseInt( k );
					if ( sequencing.indexOf( k ) === -1 && used.indexOf( result[ k ].id ) === -1 ) {
						sequenced.push( result[ k ] );
						used.push( result[ k ].id );
					}
				}
			}
		}

		return sequenced;
	}

	return false;
};

Utils.getKeyIfPropValInArray = function ( prop, val, arr ) {
	if ( typeof val !== 'undefined' && val !== null ) {
		for ( var k in arr ) {
			if ( typeof arr[ k ] !== 'undefined' && arr[ k ][ prop ] === val ) {
				return k;
			}
		}
	}
	return false;
};

Utils.recursiveObjMerge = function ( obj_a, obj_b ) {
	if ( obj_a == null || obj_b == null ) {
		return obj_a;
	}
	for ( var prop in obj_b ) {
		if ( typeof obj_b[ prop ] === 'object' && typeof obj_a[ prop ] !== 'undefined' ) {
			obj_a[ prop ] = Utils.recursiveObjMerge( obj_a[ prop ], obj_b[ prop ] );
		} else {
			obj_a[ prop ] = obj_b[ prop ];
		}
	}
	return obj_a;
};

Utils.getUrlParamName = function ( paramName ) {
	var index = -1;
	for ( var i = 0; i < Utils.constants.ALLOWABLE_QUERYSTRING.scb.length; i++ ) {
		if ( paramName.toLowerCase() === Utils.constants.ALLOWABLE_QUERYSTRING.scb[ i ].toLowerCase() ) {
			index = i;
			break;
		}
	}
	if ( index >= 0 ) {
		return Utils.constants.ALLOWABLE_QUERYSTRING.scb[ index ];
	}
	return paramName;
};

/**
 * Parse give URL string, return hostname, path, query, etc. similar to window.location
 *
 * @param {string} url URL String
 * @returns {string} url
 */
Utils.parseUrl = function ( url ) {
	var parser = document.createElement( 'a' );
	parser.href = url;
	if ( parser.protocol !== 'mailto:' ) {
		var link_path = parser.pathname.charAt( 0 ) === '/' ? parser.pathname : '/' + parser.pathname;
	} else {
		link_path = parser.pathname;
	}
	return {
		href: parser.href,
		protocal: parser.protocol,
		hostname: parser.hostname,
		port: parser.port,
		pathname: parser.hash.indexOf( '?' ) !== -1 ? link_path + parser.hash : link_path,
		rawpath: link_path,
		query: parser.query || parser.search,
		search: parser.query || parser.search,
		hash: parser.hash,
		host: parser.host,
	};
};

/**
 * Apply cookie param to given url
 *
 * @param {string} URL of the current page
 * @param {string} target URL
 * @param {boolean} targetUrlParamsToTakePrecedence Based on this value target url params will be updated.
 */

Utils.applyCookieParams = function ( $url, $swapping_attrs = '', targetUrlParamsToTakePrecedence = false ) {
	var queryString = '';
	var queryParts = [];
	var pageQueryString = '';
	var urlQueryString = '';
	var pageUrl = Utils.getPageUrl();
	var allowableQueryString = Utils.constants.ALLOWABLE_QUERYSTRING.scb;
	var allowableQueryStringOthers = Utils.constants.ALLOWABLE_QUERYSTRING.others;
	var swap_map = {};
	if ( $swapping_attrs !== '' ) {
		let $swappingList = $swapping_attrs.split( '|' );
		$swappingList.forEach( function ( attr ) {
			attr = attr.split( '=' );
			swap_map[ attr[ 0 ] ] = attr[ 1 ];
		} );
	}
	if ( pageUrl.queryString ) {
		pageQueryString = pageUrl.queryString;
		if ( pageQueryString.indexOf( '&' ) !== -1 ) {
			queryParts = pageQueryString.split( '&' );
		} else {
			queryParts.push( pageQueryString );
		}
	}

	// Get query parameters from target URL
	var urlParts = [];
	var urlBreakdown = Utils.urlBreakdown( $url );
	if ( urlBreakdown.queryString ) {
		urlQueryString = urlBreakdown.queryString;
		if ( urlQueryString.indexOf( '&' ) !== -1 ) {
			urlParts = urlQueryString.split( '&' );
		} else {
			urlParts.push( urlQueryString );
		}
	}

	// Get query parameters from Cookie
	var cookieParts = [];

	if ( allowableQueryString.length > 0 ) {
		for ( var i = 0; i < allowableQueryString.length; i++ ) {
			var query = Utils.getCookie( allowableQueryString[ i ] );

			if ( query !== null ) {
				let allowableQueryStringKey = swap_map[ allowableQueryString[ i ] ]
					? swap_map[ allowableQueryString[ i ] ]
					: allowableQueryString[ i ];
				cookieParts.push( allowableQueryStringKey + '=' + encodeURI( query ) );
			}
		}
	}

	var qsArr = [];
	// User parameter from Page URL
	for ( var j = 0; j < queryParts.length; j++ ) {
		if ( queryParts[ j ] !== '' ) {
			var ur = queryParts[ j ].split( '=' );

			// Allow only whitelisted params from pageUrl.
			if ( ! allowableQueryStringOthers.includes( ur[ 0 ] ) ) {
				continue;
			}

			// If targetUrlParamsToTakePrecedence is true and urlQueryString has the same parameter, then skip from updating the value.
			if ( targetUrlParamsToTakePrecedence && urlQueryString.indexOf( ur[ 0 ] + '=' ) !== -1 ) {
				continue;
			}

			if ( qsArr.indexOf( ur[ 0 ].toLowerCase() ) === -1 ) {
				if ( queryString !== '' ) {
					queryString += '&';
				}

				var uu = Utils.getUrlParamName( ur[ 0 ] );

				queryString += uu + '=' + ur[ 1 ];
				qsArr.push( ur[ 0 ].toLowerCase() );
			}
		}
	}

	// User parameter from Cookie only if that parameter does not exist in URL
	for ( var l = 0; l < cookieParts.length; l++ ) {
		if ( cookieParts[ l ] !== '' ) {
			var co = cookieParts[ l ].split( '=' );

			// If targetUrlParamsToTakePrecedence is true and urlQueryString has the same parameter, then skip from updating the value.
			if ( targetUrlParamsToTakePrecedence && urlQueryString.indexOf( co[ 0 ] + '=' ) !== -1 ) {
				continue;
			}

			if ( qsArr.indexOf( co[ 0 ].toLowerCase() ) === -1 ) {
				if ( queryString !== '' ) {
					queryString += '&';
				}

				var cc = Utils.getUrlParamName( co[ 0 ] );

				queryString += cc + '=' + co[ 1 ];
				qsArr.push( co[ 0 ].toLowerCase() );
			}
		}
	}

	// Use parameter from target url only if it does not exist in page URL and cookie
	for ( var k = 0; k < urlParts.length; k++ ) {
		if ( urlParts[ k ] !== '' ) {
			var qs = urlParts[ k ].split( '=' );

			if ( qsArr.indexOf( qs[ 0 ].toLowerCase() ) === -1 ) {
				if ( queryString !== '' ) {
					queryString += '&';
				}

				var qq = Utils.getUrlParamName( qs[ 0 ] );
				queryString += qq + '=' + qs[ 1 ];
			}
		}
	}
	var breakdown = Utils.parseUrl( $url );

	let queryStringArray = queryString.split( '&' );
	if ( queryString !== '' && queryStringArray.length > 0 ) {
		queryStringArray.forEach( function ( value ) {
			breakdown.rawpath = breakdown.rawpath.replace( '&' + value, '' );
		} );
	}

	if ( breakdown.protocal === 'mailto:' ) {
		return `${ breakdown.protocal }${ breakdown.hostname }${ breakdown.pathname }?${ queryString }${ breakdown.hash }`;
	} else {
		if ( $swapping_attrs !== '' && $swapping_attrs.indexOf( ',' ) !== -1 ) {
			queryString = Utils.bundleParam( queryString, $swapping_attrs );
		}
		if ( breakdown.hash.indexOf( '?' ) !== -1 ) {
			return `${ breakdown.protocal }//${ breakdown.hostname }${ breakdown.rawpath }?${ queryString }${ breakdown.hash }`;
		}

		return `${ breakdown.protocal }//${ breakdown.hostname }${ breakdown.pathname }?${ queryString }${ breakdown.hash }`;
	}
};

/**
 * bundleParam method used for Params Bundling.
 * If bundle parameters are available then it's replaced by value which are present in the queryString and append it inside the current CTA
 *
 * @param {string} queryString generated new queryString based on data-pass-params & data-cta-url-params-precedence
 * @param {*} $swapping_attrs attributes of swap-attrs
 * Utils.bundleParam('#/onboarding?country=SG&products=162,338&campaign=6203,CA001', 'subChanCode,referId=aggregator')
 */

Utils.bundleParam = function ( queryString, $swapping_attrs ) {
	let swap_map = {};
	let urlQueryString = window.location.search;
	if ( ! urlQueryString ) return queryString;
	urlQueryString = urlQueryString.substr( 1 );
	if ( ! urlQueryString ) return queryString;
	urlQueryString = urlQueryString.split( '&' );

	const allowableQueryString = Utils.constants.ALLOWABLE_QUERYSTRING.scb;
	$swapping_attrs = $swapping_attrs.split( '=' );
	swap_map = $swapping_attrs[ 0 ].split( ',' );
	let swap_str = '';
	for ( let i = 0; i < swap_map.length; i++ ) {
		if ( allowableQueryString.includes( swap_map[ i ] ) ) {
			for ( let j = 0; j < urlQueryString.length; j++ ) {
				let list = urlQueryString[ j ].split( '=' );
				if ( list[ 0 ] === swap_map[ i ] ) {
					swap_str += swap_str ? ',' : '';
					swap_str += list[ 1 ];
				}
			}
		}
	}
	if ( ! swap_str ) return queryString;

	if ( queryString.indexOf( $swapping_attrs[ 1 ] ) === -1 ) {
		queryString += '&' + $swapping_attrs[ 1 ] + `=${ swap_str }`;
	} else {
		let strList = queryString.split( '&' );
		queryString = '';
		for ( let i = 0; i < strList.length; i++ ) {
			let list = strList[ i ].split( '=' );
			queryString += queryString ? '&' : '';
			if ( list[ 0 ] === $swapping_attrs[ 1 ] ) {
				queryString += $swapping_attrs[ 1 ] + `=${ swap_str }`;
			} else {
				queryString += list[ 0 ] + '=' + list[ 1 ];
			}
		}
	}

	return queryString;
};

Utils.getCurrentCountry = function () {
	var pageContext = Utils.getPageContext();
	if ( pageContext.country ) {
		return pageContext.country;
	}
	return Utils.urlBreakdown( window.location.href ).country;
};

Utils.getCurrentLanguage = function () {
	var pageContext = Utils.getPageContext();
	if ( pageContext.language ) {
		return pageContext.language;
	}

	var queryString = window.location.href.split( '?' ),
		parts = queryString[ 0 ].replace( 'http://', '' ).replace( 'https://', '' ).split( '/' );

	if ( parts.length > 2 && parts[ 2 ] && parts[ 2 ].length === 2 ) {
		return parts[ 2 ].toLowerCase();
	}
	return document.documentElement.lang ? document.documentElement.lang.split( '-' )[ 0 ].toLocaleLowerCase() : null;
};

Utils.getLocalizedPageUrl = function ( lang, defaultLang ) {
	if ( ! lang ) {
		return;
	}

	//  Check for alternate meta
	var selector =
		lang.indexOf( '-' ) !== -1
			? 'link[rel="alternate"][hreflang="' + lang + '"]'
			: 'link[rel="alternate"][hreflang^="' + lang + '-"]';
	var alternatePageUrl = document.querySelector( selector );
	if ( alternatePageUrl && alternatePageUrl.hasAttribute( 'href' ) ) {
		if ( alternatePageUrl.getAttribute( 'href' ) ) {
			return alternatePageUrl.getAttribute( 'href' );
		}
	}

	if ( Utils.getCurrentLanguage() === lang ) {
		return window.location.href;
	}

	var currentEnvironment = Utils.getCurrentEnvironment();
	var langSegmentPosition =
		Utils.constants.DEVELOPMENT === currentEnvironment || Utils.constants.STAGING === currentEnvironment ? 3 : 2;
	var pathname = window.location.pathname;
	var parts = pathname.split( '/' );
	if (
		parts.length > langSegmentPosition &&
		parts[ langSegmentPosition ] &&
		parts[ langSegmentPosition ].length === 2
	) {
		if ( lang === defaultLang ) {
			parts.splice( langSegmentPosition, 1 );
		} else {
			parts[ langSegmentPosition ] = lang;
		}
	} else if ( lang !== defaultLang ) {
		parts.splice( langSegmentPosition, 0, lang );
	}
	return window.location.href.replace( pathname, parts.join( '/' ) );
};

Utils.createGuid = function () {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace( /[xy]/g, function ( c ) {
		var r = ( Math.random() * 16 ) | 0,
			v = c === 'x' ? r : ( r & 0x3 ) | 0x8;
		return v.toString( 16 );
	} );
};

/**
 * Get line height of an element.
 *
 * @param {object} element -Html element
 * @returns {*} -return Values
 */
Utils.getLineHeight = function ( element ) {
	var temp = document.createElement( element.nodeName );
	temp.setAttribute(
		'style',
		'margin:0px;padding:0px;visibility:hidden;font-family:' +
			element.style.fontFamily +
			';font-size:' +
			element.style.fontSize
	);
	temp.className = element.className;
	temp.innerHTML = '1';
	temp = element.parentNode.appendChild( temp );
	var ret = temp.clientHeight;
	temp.parentNode.removeChild( temp );
	return ret;
};

// Check if this page is used in app
Utils.isApp = function () {
	var $app = document.querySelector( 'meta[name="sc:is-app"]' );
	if ( $app ) {
		return $app.getAttribute( 'content' ) === 'true';
	}
	return false;
};
/**
 * Remove diacritics (accents) from a string
 *
 * @param {string} str The input string from which we will remove strings with diacritics
 * @returns {string} str
 */
Utils.removeDiacritics = function ( str ) {
	var diacriticsMap = {
		A: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g,
		AA: /[\uA732]/g,
		AE: /[\u00C6\u01FC\u01E2]/g,
		AO: /[\uA734]/g,
		AU: /[\uA736]/g,
		AV: /[\uA738\uA73A]/g,
		AY: /[\uA73C]/g,
		B: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g,
		C: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g,
		D: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g,
		DZ: /[\u01F1\u01C4]/g,
		Dz: /[\u01F2\u01C5]/g,
		E: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g,
		F: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g,
		G: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g,
		H: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g,
		I: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g,
		J: /[\u004A\u24BF\uFF2A\u0134\u0248]/g,
		K: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g,
		L: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g,
		LJ: /[\u01C7]/g,
		Lj: /[\u01C8]/g,
		M: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g,
		N: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g,
		NJ: /[\u01CA]/g,
		Nj: /[\u01CB]/g,
		O: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g,
		OI: /[\u01A2]/g,
		OO: /[\uA74E]/g,
		OU: /[\u0222]/g,
		P: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g,
		Q: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g,
		R: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g,
		S: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g,
		T: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g,
		TZ: /[\uA728]/g,
		U: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g,
		V: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g,
		VY: /[\uA760]/g,
		W: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g,
		X: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g,
		Y: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g,
		Z: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g,
		a: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g,
		aa: /[\uA733]/g,
		ae: /[\u00E6\u01FD\u01E3]/g,
		ao: /[\uA735]/g,
		au: /[\uA737]/g,
		av: /[\uA739\uA73B]/g,
		ay: /[\uA73D]/g,
		b: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g,
		c: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g,
		d: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g,
		dz: /[\u01F3\u01C6]/g,
		e: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g,
		f: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g,
		g: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g,
		h: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g,
		hv: /[\u0195]/g,
		i: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g,
		j: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g,
		k: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g,
		l: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g,
		lj: /[\u01C9]/g,
		m: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g,
		n: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g,
		nj: /[\u01CC]/g,
		o: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g,
		oi: /[\u01A3]/g,
		ou: /[\u0223]/g,
		oo: /[\uA74F]/g,
		p: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g,
		q: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g,
		r: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g,
		s: /[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g,
		ss: /[\u00DF]/g,
		t: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g,
		tz: /[\uA729]/g,
		u: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g,
		v: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g,
		vy: /[\uA761]/g,
		w: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g,
		x: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g,
		y: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g,
		z: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g,
	};
	for ( var x in diacriticsMap ) {
		// Iterate through each keys in the above object and perform a replace
		str = str.replace( diacriticsMap[ x ], x );
	}
	return str;
};

/**
 * Check if a given URL is a form URL.
 *
 * @param {string} url The URL.
 * @returns {string} url bool True if it's form URL, false otherwise.
 */
Utils.isForm = function ( url ) {
	var formRegex =
		/(.*\/apply\/)|(.*form(s)?\.online\.standardchartered\.com.*)|(.*online\.form(s)?\.standardchartered\.com.*)|(.*sc\.com\/retail\/.*)|(.*myinfosg\.api\.gov\.sg\/*)|(.*myinfo\.gov\.sg\/*)|(.*origination\.sc\.com\/*)|(.*ibank\.standardchartered\.com*)|(.*onlineforms\.standardchartered\.com*)|(.*ebank\.standardchartered\.com*)|(.*service\.standardchartered\.com*)|(.*onlinecasa\.standardchartered\.com*)/gi;
	return formRegex.test( url );
};

/**
 * Check if tracking parameters should be carried forward to the given URL.
 *
 * @param {*} url -url
 * @returns {*} bool True if parameters should be carried forward. False otherwise.
 */
Utils.shouldCarryTrackingParams = function ( url ) {
	if ( Utils.isForm( url ) ) {
		return true;
	}
	var partnerRegex = [
		/http(s):\/\/www.royalsundaram.in\/.*/gi,
		/http(s):\/\/www.maxbupa.com\/.*/gi,
		/http(s):\/\/www.bharti-axagi.co.in\/.*/gi,
		/http(s):\/\/www.iciciprulife.com\/.*/gi,
		/http(s):\/\/www.einsure.allianz.com.sg\/.*/gi,
		/http(s):\/\/www.allianz-travel-insure.com.sg\/.*/gi,
		/http(s):\/\/www.lin.ee\/.*/gi,
		/http(s):\/\/www.piapp.com\/.*/gi,
	];
	for ( var i = 0; i < partnerRegex.length; i++ ) {
		if ( partnerRegex[ i ].test( url ) ) {
			return true;
		}
	}
	return false;
};

/**
 * Method to get localstorage value.
 * @param {string} key
 */
Utils.getLocalStorageWithExpiry = function ( key ) {
	const itemStr = localStorage.getItem( key );
	// if the item doesn't exist, return null
	if ( ! itemStr ) {
		return null;
	}
	const item = JSON.parse( itemStr );
	const now = new Date();
	// compare the expiry time of the item with the current time
	if ( now.getTime() > item.expiry ) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem( key );
		return null;
	}
	return item.value;
};

globalAny.Utils = Utils;
